import React, { Component } from "react";
import { Link } from "react-router-dom";
import ICreatePickListDTO from "../../../models/DTO/ICreatePickListDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IPick_List from "../../../models/IPick_List";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import UserService from "../../../services/UserService";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    cancelFn: () => void;
    pickLists: IPick_List[];
    payload: ICreatePickListDTO;
};

type State = {};

export default class PickListExistsModal extends Component<Props, State> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    confirmCreatePickList = () => {
        this.props.socket.emit(EndpointsEnum.OrderCreatePickList, this.props.payload);
    };

    render() {
        return (
            <div className={"PickListExistsModal p-2"}>
                <div className="">
                    <OwTitle className={""} title={"pick_list_exists"} />
                </div>

                <div className={"mt-3"}>
                    <div className="">
                        <OwLabel title={"the_following_pick_lists_exist_already"} />
                        <div>
                            {this.props.pickLists.map((pickList) => {
                                return (
                                    <div key={pickList.guid} className={"mt-2"}>
                                        <span className={"me-2"}>
                                            {pickList.is_locked ? (
                                                <i className={"fad fa-lock-alt"} />
                                            ) : (
                                                <i className={"fad fa-lock-open-alt"} />
                                            )}
                                        </span>
                                        <Link to={`/pick_lists/${pickList.guid}`}>{pickList.name}</Link>
                                        <OwLabel
                                            title={"created_at"}
                                            isBold={true}
                                            className={"ms-3 me-2"}
                                            noBottomMargin={true}
                                            postText={":"}
                                        />
                                        {UserService.parseDate(pickList.created_at)}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className={"mt-3"}>
                    <OwButton title={"continue"} fn={this.confirmCreatePickList} />
                    <OwButton title={"cancel"} className={"ms-2 btn-danger"} fn={this.props.cancelFn} />
                </div>
            </div>
        );
    }
}
